import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicUnblock({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12 7.25c.97 0 1.75.78 1.75 1.75v5c0 .97-.78 1.75-1.75 1.75H4c-.97 0-1.75-.78-1.75-1.75V9c0-.97.78-1.75 1.75-1.75h8zm0 1.5H4a.25.25 0 00-.25.25v5c0 .14.11.25.25.25h8c.14 0 .25-.11.25-.25V9a.25.25 0 00-.25-.25zm-4 1A1.25 1.25 0 018.75 12v.75a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5V12A1.25 1.25 0 018 9.75zM8 0c2.35 0 4.25 1.9 4.25 4.25v.25a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-.25a2.75 2.75 0 00-5.5 0v2a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-2C3.75 1.9 5.65 0 8 0z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicUnblock.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicUnblock.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicUnblock svgRef={ref} {...props} />);
export default ForwardRef;
